import { render } from "./ObjectItem.vue?vue&type=template&id=47a9b274&ts=true"
import script from "./ObjectItem.vue?vue&type=script&lang=ts"
export * from "./ObjectItem.vue?vue&type=script&lang=ts"

import "./ObjectItem.vue?vue&type=style&index=0&id=47a9b274&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__